import {getAPI} from "services/http";
import {failureToast} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import {endpoint} from "views/pages/manage/common/constant";

const getFormattedProcessTagType =(arr=[])=>{
    if(arr && arr.length){
        let formattedArray = [];
        arr.forEach((item)=>{
            let obj = {
                value : item.id,
                label : item.tagTypeDispValue,
                ...item
            }
            formattedArray.push(obj);
        });
        return formattedArray;
    }
}

const getProcessTagType = async ()=>{
    let  url = endpoint.process_Tag.getAllActive
    return new Promise(async(resolve,reject)=>{
        let result = {
            error : false,
            data : []
        };
        await getAPI(
            url,
            (data) => {
                result['data'] = getFormattedProcessTagType(data.data);
                resolve(result);
            },
            (data) => {
                reject({error:true,message:data?.message})
                failureToast(data["message"]);
            }
        );
    })
}

export default getProcessTagType;